export default {"src":"/_next/static/media/NavDesktopIcon.22a0cb9a.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};